import { CardButton } from '@/domain/mitarbeiter/features/anlageassistent/components/CardButton';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { anstellungstyp } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/anstellungstyp';
import { FristenGrund } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/fristenGrund';
import { Title } from '@e2n/ui/v2';
import {
  faCalendarExclamation,
  faFileContract,
} from '@fortawesome/pro-regular-svg-icons';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useFristenContext } from './context/useFristenContext';

export function FristenSuggestions() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { setOpenCreateSheet, setCreateSheetDefaultValues } =
    useFristenContext();
  const anstellungstypForSuggestion = [
    anstellungstyp.VOLLZEIT,
    anstellungstyp.TEILZEIT,
    anstellungstyp.AZUBI,
  ];
  const hasAnstellungstypForSuggestion = anstellungstypForSuggestion.some(
    (anstellungstyp) =>
      anstellungstyp ===
      form.state.values.anstellungsverhaeltnis.anstellung.anstellungstyp,
  );
  const hasBefristung =
    form.state.values.anstellungsverhaeltnis.anstellung.befristung;

  if (!hasAnstellungstypForSuggestion && !hasBefristung) return null;

  return (
    <div className="flex flex-col gap-4 w-full">
      <Title>
        {t(
          'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.fristenSuggestions.title',
        )}
      </Title>
      <div className="grid md:grid-cols-2 gap-4">
        {hasAnstellungstypForSuggestion && (
          <CardButton
            icon={faCalendarExclamation}
            label={t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.fristenSuggestions.probezeit',
            )}
            onClick={() => {
              setCreateSheetDefaultValues({
                fristdatum: dayjs().add(3, 'month').toISOString(),
                grund: FristenGrund.PROBEZEIT_ENDE,
                erinnerungsZeit: [],
              });

              setOpenCreateSheet(true);
            }}
          />
        )}
        {hasBefristung && (
          <CardButton
            icon={faFileContract}
            label={t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.fristenSuggestions.vertragsende',
            )}
            onClick={() => {
              setCreateSheetDefaultValues({
                fristdatum:
                  form.state.values.anstellungsverhaeltnis.anstellung
                    .befristung,
                grund: FristenGrund.ARBEITSVERTRAG_ENDE,
                erinnerungsZeit: [],
              });
              setOpenCreateSheet(true);
            }}
          />
        )}
      </div>
    </div>
  );
}
